import { render, staticRenderFns } from "./DialogAddEditSwapGroup.vue?vue&type=template&id=7f8b97da&scoped=true"
import script from "./DialogAddEditSwapGroup.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditSwapGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b97da",
  null
  
)

export default component.exports